<template>
  <v-container fluid>
    <v-parallax 
    :src="require('@/assets/citybridge.jpg')"
    aspect-ratio="1.7"
    height="300"
    class="my-2">
      <v-layout align-center justify-space-around row wrap fill-height>
        <h1 class="display-3 font-weight-thin white--text ma-2">Acerca de Exicon Investment Banking</h1>          
      </v-layout>
    </v-parallax>
    <v-layout row wrap
    text-xs-center
    justify-center>
      <v-flex xs12
      class="my-4">
        <v-layout row wrap text-xs-center 
        justify-center
        class="my-2">
          <h1 class="display-2 font-weight-thin">Nuestro Objetivo</h1>
        </v-layout>
        <v-layout row wrap
        text-xs-center 
        justify-center
        class="my-2">
          <h1 class="display-5 font-weight-thin">Para tener éxito, nos enfocamos en mercados, industrias y tipos de negocios que conocemos bien.</h1>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm6 md4
      class="my-2 px-2">
        <v-hover>
          <v-card
          slot-scope="{ hover }"
          :class="`elevation-${hover ? 12 : 2}`">
            <v-img
            src="https://sociable.co/wp-content/uploads/2018/05/outsourcing-latin-america-1280x720.jpg"
            height="250px"
            contain
            >
            </v-img>

            <v-card-title primary-title>
              <div>
                <div class="headline">Nos enfocamos en las empresas en América Latina</div>
                <span class="grey--text">Nos enfocamos en ayudar a las empresas de América del Sur y el Caribe a acceder a recursos de capital global.</span>
              </div>
            </v-card-title>
          </v-card>
        </v-hover>
      </v-flex>
      <v-flex xs12 sm6 md4
      class="my-2 px-2">
        <v-hover>
          <v-card
          slot-scope="{ hover }"
          :class="`elevation-${hover ? 12 : 2}`">
            <v-img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSUPfRF0HG4ySmMdtel5y74t6aBdbQKrwORbQ&usqp=CAU"
            height="250px"
            contain
            >
            </v-img>

            <v-card-title primary-title>
              <div>
                <div class="headline">Nos gustan las industrias con productos diferenciados.</div>
                <span class="grey--text">Por ejemplo, empresas de manufactura, bienes de consumo, distribución de servicios de salud y servicios financieros.</span>
              </div>
            </v-card-title>
          </v-card>
        </v-hover>
      </v-flex>
      <v-flex xs12 sm6 md4
      class="my-2 px-2">
        <v-hover>
          <v-card
          slot-scope="{ hover }"
          :class="`elevation-${hover ? 12 : 2}`">
            <v-img
            src="https://www.thenakedheadhunter.com/wp-content/uploads/2017/04/boardroom-e1491318161397.jpg"
            height="250px"
            contain
            >
            </v-img>

            <v-card-title primary-title>
              <div>
                <div class="headline">Preferimos las empresas con posiciones líderes en el mercado.</div>
                <span class="grey--text">
                  Buscamos negocios generadores de efectivo con liderazgo en el mercado y por encima de USD 25 millones en ventas anuales.
                </span>
              </div>
            </v-card-title>
          </v-card>
        </v-hover>
      </v-flex>
      <v-flex xs12
      class="my-4">
        <v-layout row wrap
        text-xs-center
        justify-center
        class="my-2 mx-2">
          <h1 class="display-2 font-weight-thin my-2">Nuestro Equipo</h1>
        </v-layout>
        <v-layout row wrap
        text-xs-center
        justify-center
        class="my-2 mx-2">
          <h1 class="display-5 font-weight-thin my-2">
            Benefíciese de nuestro acceso a inversores clave en los mercados de capital a nivel mundial y nuestra experiencia de cierre de transacciones profesionales.
          </h1>
        </v-layout>
        <v-layout row wrap
        text-xs-center
        justify-center
        class="my-2 mx-2">
          <v-expansion-panel popout>
            <v-expansion-panel-content
              v-for="(member, i) in members"
              :key="i"
              hide-actions
            >
              <v-layout
                slot="header"
                align-center
                row
                spacer
              >
                <v-flex xs4 sm2 md1>
                  <v-avatar
                    slot="activator"
                    size="48px"
                  >
                    <img
                      v-if="member.avatar"
                      :src="require('@/assets/' + member.avatar + '.png')"
                      alt="Team Member"
                    >
                  </v-avatar>
                </v-flex>

                <v-flex sm5 md3 hidden-xs-only>
                  <strong v-html="member.name"></strong>
                </v-flex>

                <v-flex no-wrap xs5 sm3>
                  <span v-html="member.title"></span>
                </v-flex>

                <v-flex
                  v-if="member.excerpt"
                  class="grey--text"
                  ellipsis
                  hidden-sm-and-down
                >
                  &mdash;
                  {{ member.excerpt }}
                </v-flex>
              </v-layout>

              <v-card>
                <v-divider></v-divider>
                <v-card-text>
                  <span>{{member.content}}</span>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
        members: [
          {
            avatar: 'mario',
            name: 'Mario Lizana-Allende',
            title: 'Director General',
            excerpt: 'Fundó Exicon en 2003',
            content: 'Mario Lizana-Allende fundó Exicon luego de haber sido Gerente para América Latina y el Caribe de KPMG LLP en Miami, Estados Unidos. Trae consigo años de experiencia en finanzas corporativas y relaciones con los mayores inversores estratégicos y financieros de Estados Unidos, Asia y Europa. Mario es Licenciado en Derecho por la Universidad Complutense de Madrid y Máster en Administración de Empresas - MBA- por la Universidad Autónoma de Madrid. Se desempeñó como Presidente de la Cámara de Comercio Chile-Estados Unidos en Estados Unidos y fue Presidente del Comité Fundador de la Cámara de Comercio Chilena de Colombo en Colombia. Habla con fluidez español, alemán e inglés.'
          },
          {
            avatar: 'cecil',
            name: 'Cecil Yi Peng Ang',
            title: 'Director',
            excerpt: 'Se unió a Exicon en 2016',
            content: 'Cecil Ang se unió a Exicon después de fundar Betafish Pte Ltd, una compañía de tecnología financiera en Singapur y Silicon Valley, California, EE. UU. Antes de Betafish, Cecil pasó cinco años como asociado sénior de investigación en Sands Capital Management LLC (EE. UU.), Una empresa de inversión que gestiona más de USD 100B. Cecil se graduó con la más alta distinción en Economía y Finanzas de la Universidad de Virginia, EE. UU. Y es Candidato de Analista Financiero Colegiado Nivel III. Habla inglés, mandarín y español con fluidez.'
          }
        ]
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/acerca.vue